import { NimbusPermission } from '@nimbus-global/features/permissions/models/enums/nimbus-permission.enum';
import { CompanionToolName } from './companion-conversation.model';

const CompanionToolPermissions: Readonly<Partial<Record<string, readonly NimbusPermission[]>>> = {
  [CompanionToolName.ChangeVirtualUserBotConfiguration]: [NimbusPermission.VirtualUsersUpdate],
  [CompanionToolName.CreateBotConfiguration]: [NimbusPermission.BotTemplatesUpdate],
  [CompanionToolName.CreateVirtualUser]: [NimbusPermission.BotTemplatesUpdate, NimbusPermission.VirtualUsersCreate],
  [CompanionToolName.FindBotConfigurationByName]: [NimbusPermission.BotTemplatesUpdate],
  [CompanionToolName.FindVirtualUserByName]: [NimbusPermission.VirtualUsersRead],
  [CompanionToolName.GetServiceActivityOverTime]: [NimbusPermission.ReadOperationsServices],
  [CompanionToolName.GetServiceConversationCountsByOutcome]: [NimbusPermission.ReadOperationsServices],
  [CompanionToolName.GetServiceStatistics]: [NimbusPermission.ReadOperationsServices],
  [CompanionToolName.GetServiceTrends]: [NimbusPermission.ReadServiceStatisticsReporting],
  [CompanionToolName.GetTotalServiceConversationCount]: [NimbusPermission.ReadOperationsServices],
  [CompanionToolName.GetVirtualUser]: [NimbusPermission.VirtualUsersRead],
  [CompanionToolName.ListBotConfigurations]: [NimbusPermission.BotTemplatesUpdate],
  [CompanionToolName.ListVirtualUsers]: [NimbusPermission.VirtualUsersRead],
  [CompanionToolName.UpdateBotConfiguration]: [NimbusPermission.BotTemplatesUpdate],
  [CompanionToolName.UpdateVirtualUser]: [NimbusPermission.VirtualUsersUpdate],
};

export function getCompanionToolPermissions(toolName?: string): readonly NimbusPermission[] | undefined {
  const qualifiedToolName = toolName?.startsWith('nimbus_') ? toolName : `nimbus_${toolName}`;
  return CompanionToolPermissions[qualifiedToolName];
}
